// function to act as a class
function BoldFormatter(_ref) {
  let {
    value
  } = _ref;
  return `<span style="font-weight:500;color:#3c4248">${value}</span>`;
}
export default BoldFormatter;